/**
 * External dependencies.
 */
import React from "react";
import Pagination from "@etchteam/next-pagination";

/**
 * Internal dependencies
 */
import ArticleContent from "./article-content";
import { ArticleProps } from "types/article";

interface ArticlesProps {
  articles: {
    data: ArticleProps[];
    meta: any;
  };
  pagination: boolean;
}

const Articles: React.FC<ArticlesProps> = ({ articles, pagination }) => {
  if (!articles.data || !articles.data.length) {
    return null;
  }

  const styles = {
    "next-pagination": "pagination pagination--blog",
    "next-pagination__list": "",
    "next-pagination__link--current": "current",
    "next-pagination__link--disabled": "disabled",
    "next-pagination__form": "hidden",
  };

  return (
    <div className="container">
      <div className="articles">
        <ul>
          {articles.data.map((article: ArticleProps, index: number) => {
            return (
              <li key={index}>
                <ArticleContent data={article} />
              </li>
            );
          })}
        </ul>
      </div>

      {pagination && articles.meta.pagination.pageCount > 1 && (
        <Pagination
          total={articles.meta.pagination.pageCount}
          theme={styles}
          sizes={[1]}
          perPageText={""}
          setPageSizeText={""}
        />
      )}
    </div>
  );
};

export default Articles;
